<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-09 14:13:38
 * @LastEditTime: 2022-03-10 18:18:03
-->
<template>
  <div style="flex: 1;">
    <el-dropdown trigger="click" style="width: 100%; background-color: white" placement="bottom-start" ref="dropdown">
      <div class="terminal-input">
        <div v-if="project.groupId" style="height: 26px;line-height: 26px; padding-left: 15px;padding-right: 15px">
          {{ project.groupName }}
        </div>
        <div v-else style="height: 26px;line-height: 26px; color: #C0C4CC;padding-left: 15px;padding-right: 15px">
          {{ $t('lang.groupinglist.selector') }}
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <div class="select">
          <div class="select-project">
            <el-tree v-if="
              user_iscustomer == 2 || (user_iscustomer == 1 && user_ctid == 0)
            " style="overflow:auto;height: 200px" v-infinite-scroll="scrollLoad" ref="groupTrees"
              :highlight-current="true" :data="groupList" node-key="groupId" :props="defaultProps"
              @node-click="clickProject">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span style="font-size: 16px">{{ node.label }}</span>
              </span>
            </el-tree>
            <el-tree v-else lazy style="overflow:auto;height: 200px" v-infinite-scroll="scrollLoad" ref="groupTrees"
              :highlight-current="true" :expand-on-click-node="false" @node-click="clickProject" :load="loadNode"
              node-key="groupId" :data="groupList" @current-change="treeChange" :props="defaultProps">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span style="font-size: 16px">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { getFirstGroup, getSecondGroup } from "@/api/cloudMonitor/projectGroup";
import { projectConfig } from "@/mixins/projectConfig";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
export default {
  mixins: [projectConfig],
  name: "projectTress",
  data() {
    return {
      defaultProps: {
        chirldren: "children",
        label: "groupName",
      },
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
    };
  },
  // 进来是刷新当前项目下的设备列表，处理添加设备后返回设备组态没有数据没有刷新的问题
  activated() {
    this.clickProject(this.$refs["groupTrees"].getCurrentNode());
  },
  methods: {
    // 根据用户Id查询分组
    getByUser(userId) {
      let params = {
        current: this.current,
        size: this.size,
        userid: userId,
      };
      this.project = {};
      getFirstGroup(params)
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.groupList = data.records;
            this.$nextTick(() => {
              this.project = this.groupList[0] || {};
              // 设置默认选项
              this.$refs["groupTrees"].setCurrentKey(this.groupList[0].groupId);
              this.$emit("clickProject", this.groupList[0]);
            });
          } else if (res.data.code === 3) {
            this.$message.warning("权限不足，无法操作！");
          }
        })
        .catch(() => { });
    },
    // 点击项目节点
    clickProject(node) {
      this.$refs.dropdown.hide();
      this.project = node ? node : {};
      this.$emit("clickProject", node ? node : {});
    },
    // 重新选择
    treeChange(val) {
      this.$emit("projectChange");
    },
  },
};
</script>
<style scoped>
.terminal-input {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-height: 26px;
  cursor: pointer;
  overflow: hidden;
}

.el-tree {
  min-width: 200px;
}
</style>
